import type { IconDefinition } from '../index.tsx';

export const iconFile: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconFile',
  icon: [16, 16, [], '', 'M7 0H2V16H14V7H7V0Z M9 0V5H14L9 0Z'],
};
